import React, { useState, useEffect } from 'react';
import Modal from "../util/Modal";
import PropTypes from "prop-types";
import ax from '../util/axios';

import { IntlProvider } from "react-intl";
import { translations } from "../util/i18n";

// TODO: support admin/org paths
import {
  poll_csv_admin_area_simulations_path,
  download_csv_admin_area_simulations_path
} from '../../../../routes';

const DownloadCsvModal = (props) => {
  const [error, setError] = useState(null);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (props.open) {
      sequence()
    }

    return () => {
      resetTimer()
    }
  }, [props.open]);

  const sequence = async() => {
    setError(null);
    const response = await initCsv()

    if (!response) return;

    if (response.data && response.data.job_id) {
      // Async endpoint (admin simulations index): poll the job until the CSV is ready
      const jobId = response.data.job_id;
      pollSimulationsCsv(jobId)

      setTimer(setInterval(() => {
        pollSimulationsCsv(jobId);
      }, 1000));
    } else {
      // Synchronous endpoints return the CSV body directly
      downloadBlob(new Blob([response.data], { type: 'text/csv' }));
      props.openHandler(false);
    }
  }

  const resetTimer = () => {
    if (timer) {
      clearInterval(timer);
      setTimer(null);
    }
  }

  const initCsv = async() => {
    try {
      return await ax.get(props.csvUrl);
    } catch (error) {
      setError(error);
    }
  }

  const pollSimulationsCsv = async(jobId) => {
    try {
      const response = await ax.get(poll_csv_admin_area_simulations_path + '?job_id=' + jobId);

      if (response.data.status == 'failed') {
        setError(true);
        resetTimer();
      }

      if (response.data.status == 'completed') {
        resetTimer();
        downloadCsv(jobId);
      }
    } catch (error) {
      setError(error);
      resetTimer();
    }
  }

  const downloadCsv = async(jobId) => {
    try {
      const response = await ax.get(download_csv_admin_area_simulations_path + '?job_id=' + jobId, { responseType: 'blob' });
      downloadBlob(response.data);
      props.openHandler(false);
    } catch (error) {
      setError(error);
    }
  }

  const downloadBlob = (data) => {
      const url = window.URL.createObjectURL(data);
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', 'simulations.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
  }

  const errorContent = () => {
    return (
      <div className="display-flex flex-column">
        <p>Something went wrong, please retry</p>
      </div>
    );
  }

  const loadingContent = () => {
    return (
      <div className="display-flex flex-column">
        <p>Your report is being generated...</p>
        <div className="spinner">
          <ion-icon name="sync-outline"></ion-icon>
        </div>
      </div>
    );
  };

  return (
    <IntlProvider
      locale={window._FLAIM_LOCALE}
      key={window._FLAIM_LOCALE}
      messages={translations[window._FLAIM_LOCALE]}
    >
      {props.open === true && (
        <Modal
            open={props.open}
            onClose={() => {
              props.openHandler(false);
            }}
            title="shared.forms.export_as_csv"
            content={error ? errorContent() : loadingContent()}
            classNameForContent="cancel-overflow-auto"
        />
      )}
    </IntlProvider>
  );
};

DownloadCsvModal.propTypes = {
  open: PropTypes.bool.isRequired,
  openHandler: PropTypes.func.isRequired,
  csvUrl: PropTypes.string.isRequired
};

export default DownloadCsvModal;